/** @format */

export function getLocalRestEndpoint(frontendPort: string): string {
  if (!/^\d+$/.test(frontendPort)) throw new Error(`Invalid local frontend port: ${frontendPort}`);

  const port = Number(frontendPort);
  if (!Number.isSafeInteger(port) || port < 4200 || port > 65535) {
    throw new Error(`Invalid local frontend port: ${frontendPort}`);
  }

  const slot = Math.floor((port - 4200) / 2);
  return `http://localhost:${3001 + slot}`;
}
